'use strict';

import {contractModel} from "../../models/contractmodel.js";
import {reportingModel} from "../../models/reportingmodel.js";
import {DSSectionCtrl} from "./dssectionctrl.js";

export class DS42PaymentsCtrl extends DSSectionCtrl
{
	reportings = {
		t1: [],
		t2: [],
		t3: []
	};

	constructor($scope, $filter, jsDataService, $mdDialog) {
		super($scope, $filter, jsDataService, $mdDialog);
		this.dataConstruct();
	}

    dataConstruct(){
        const rawItem = this.jsDataService.get('item', {}) || {};

        this.item = new contractModel(rawItem, this.$filter, this.jsDataService);

        let rep = (this.item && this.item.reportings) || null;

        if (!this._hasAnyReports(rep)) {
            rep = rawItem.reportings || null;
        }

        if (!this._hasAnyReports(rep)) {
            rep = this.jsDataService.get('reportings', null);
        }

        if (this._hasAnyReports(rep)) {
            this.setReportings(rep);
        }
    }

    _hasAnyReports(rep){
        return !!(rep &&
            ((Array.isArray(rep.t1) && rep.t1.length) ||
                (Array.isArray(rep.t2) && rep.t2.length) ||
                (Array.isArray(rep.t3) && rep.t3.length)));
    }

    setReportings(reportings){
        this.reportings = { t1: [], t2: [], t3: [] };
        const groups = ['t1','t2','t3'];
        for (const g of groups) {
            const arr = Array.isArray(reportings[g]) ? reportings[g] : [];
            for (const reportingData of arr) {
                this.reportings[g].push(new reportingModel(reportingData, this.$filter, this.jsDataService));
            }
        }
    }
	
	modelValue(name){
		if(typeof(this.item) !== 'undefined' && this.item instanceof contractModel){
			return this.item.getValue(name);
		}
		return '';
	}
	
	autosavePostFields(){
		const collection = ['payment_ceiling_id', 'no_profit_rule', 'late_payment_interest', 'account_holder', 'iban', 'in_euros', 'swift', 'bank_name'];
		let returnObject = {
			dsmodel: {}
		};
		for(let fld of collection){
			returnObject.dsmodel[fld] = this.item[fld];
		}
		return returnObject;
	}
	
	removeReporting(ev, reporting){
		if(this.jsDataService.get('cfgReportingRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgReportingRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: reporting.id
					}
				}).then((results) => {
					if(results.data.success && typeof(results.data.reportings) !== 'undefined'){
						this.setReportings(results.data.reportings);
					}
				});
			}, () => {});
		}
	}
	
	addReporting(ev){
		this.reportingEditor(ev, new reportingModel({}, this.$filter, this.jsDataService));
	}
	
	editReporting(ev, reporting){
		this.reportingEditor(ev, reporting);
	}
	
	reportingEditor(ev, reporting){
		
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "reporting", "allreportings", this.reportingEditorDialogCtrl],
			templateUrl: 'contracts/reporting_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				reporting: reporting,
				allreportings: this.reportings
			}
		}).then((reportingItem) => {
			if(this.jsDataService.get('cfgReportingSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgReportingSaveUrl'),
					method: 'POST',
					data: reportingItem.getData()
				}).then((response) => {
					if(response.data.success && typeof(response.data.reportings) !== 'undefined'){
						this.setReportings(response.data.reportings);
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgReportingSaveUrl'));
			}
		}, () => {});
	}
	
	reportingEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, reporting, allreportings, badIntervalStatus){
		let initialType;
		$scope.item = angular.copy(reporting);
		$scope.allreportings = allreportings;
		$scope.classif = jsDataService.get('cfgClassif', {});
		$scope.paymentTypeChanged = function(){
			
		};
		
		$scope.isInitial = function(){
			return ($scope.item.payment_type_id == 1);
		};
		
		$scope.isFinal = function(){
			return ($scope.item.payment_type_id == 9);
		};
		
		$scope.fromMin = function(){
			let min = 1;
			if($scope.item.id > 0){
				let breaked = false;
				for(let rpt of $scope.allreportings.t2){
					if(rpt.id == $scope.item.id){
						breaked = true;
						break;
					}
					if(rpt.month_to > 0){
						min = (parseInt(rpt.month_to)+1);
					}
				}
				if(!breaked){
					for(let rpt of $scope.allreportings.t3){
						if(rpt.id == $scope.item.id){
							breaked = true;
							break;
						}
						if(rpt.month_to > 0){
							min = (parseInt(rpt.month_to)+1);
						}
					}
				}
			}
			else{
				if($scope.isFinal()){
					if($scope.allreportings.t3.length > 0){
						if($scope.allreportings.t3[$scope.allreportings.t3.length-1].month_to > 0){
							min = (parseInt($scope.allreportings.t3[$scope.allreportings.t3.length-1].month_to) + 1);
						}
					}
					else if($scope.allreportings.t2.length > 0){
						if($scope.allreportings.t2[$scope.allreportings.t2.length-1].month_to > 0){
							min = (parseInt($scope.allreportings.t2[$scope.allreportings.t2.length-1].month_to) + 1);
						}
					}
				}
				else{
					if($scope.allreportings.t2.length > 0){
						if($scope.allreportings.t2[$scope.allreportings.t2.length-1].month_to > 0){
							min = (parseInt($scope.allreportings.t2[$scope.allreportings.t2.length-1].month_to) + 1);
						}
					}
				}
			}
			return min;
		};
		
		$scope.toMin = function(){
			let min = 2;
			if($scope.item.month_from > 0){
				min = parseInt($scope.item.month_from);
			}
			return min;
		};
		
		$scope.toMax = function(){
			let max = null;
			if($scope.item.id > 0){
				let found = false;
				let breaked = false;
				for(let rpt of $scope.allreportings.t2){
					if(rpt.id == $scope.item.id){
						found = true;
						continue;
					}
					if(found && rpt.month_from > 0){
						max = (parseInt(rpt.month_from) - 1);
						breaked = true;
						break;
					}
				}
				if(!breaked){
					for(let rpt of $scope.allreportings.t3){
						if(rpt.id == $scope.item.id){
							found = true;
							continue;
						}
						if(found && rpt.month_from > 0){
							max = (parseInt(rpt.month_from) - 1);
							breaked = true;
							break;
						}
					}
				}
			}
			else{
				if(!$scope.isFinal() && $scope.allreportings.t3.length > 0 && $scope.allreportings.t3[0].month_from > 0){
					max = (parseInt($scope.allreportings.t3[0].month_from) - 1);
				}
			}
			return max;
		};
		
		function init(){
			if(!isNaN($scope.item.month_from)){
				$scope.item.month_from = parseInt($scope.item.month_from);
			}
			else{
				$scope.item.month_from = 0;
			}
			if(!isNaN($scope.item.month_to)){
				$scope.item.month_to = parseInt($scope.item.month_to);
			}
			else{
				$scope.item.month_to = 0;
			}
			if($scope.item.submission_date > 0){
				$scope.item.submission_date = new Date($scope.item.submission_date * 1000);
			}
			else{
				$scope.item.submission_date = new Date();
			}
			if(!isNaN($scope.item.amount)){
//				$scope.item.amount = parseInt($scope.item.amount);
				$scope.item.amount = Number(parseFloat($scope.item.amount).toFixed(2));
			}
			else{
				$scope.item.amount = 0;
			}
			if(!isNaN($scope.item.guarantee_amount)){
//				$scope.item.guarantee_amount = parseInt($scope.item.guarantee_amount);
				$scope.item.guarantee_amount = Number(parseFloat($scope.item.guarantee_amount).toFixed(2));;
			}
			else{
				$scope.item.guarantee_amount = 0;
			}
			$scope.item.guarantee_amount_on = ($scope.item.guarantee_amount_on == 1);
			if($scope.item.guarantee_receipt_date > 0){
				$scope.item.guarantee_receipt_date = new Date($scope.item.guarantee_receipt_date * 1000);
				$scope.item.guarantee_receipt_on = true;
			}
			else{
				$scope.item.guarantee_receipt_on = false;
				$scope.item.guarantee_receipt_date = new Date();
			}
			initialType = $scope.item.payment_type_id;
		}
		init();
		
		function getCaterory(id){
			if(id == 1){
				return 't1';
			}
			if(id == 9){
				return 't3';
			}
			return 't2';
		}
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function(){
			if(initialType != $scope.item.payment_type_id){
				let ord = 0;
				for(let cat in $scope.allreportings){
					ord += $scope.allreportings[cat].length;
				}
				$scope.item.ord = ord;
			}
			if($scope.isInitial()){
				$scope.item.submission_date = '0';
			}
			else{
				$scope.item.submission_date = $filter('date')($scope.item.submission_date_cet, 'yyyy-MM-dd');
			}
			if($scope.item.guarantee_receipt_on){
				$scope.item.guarantee_receipt_date = $filter('date')($scope.item.guarantee_receipt_date_cet, 'yyyy-MM-dd');
			}
			else{
				$scope.item.guarantee_receipt_date = '0';
			}
			$mdDialog.hide($scope.item);
		};

		$scope.$watch(
			() => $scope.item.month_to,
			(newValue, oldValue) => {
				if (newValue !== oldValue) {
					$scope.triggerBadIntervalCheck();
				}
			}
		);

		$scope.badIntervalStatus = badIntervalStatus;

		$scope.triggerBadIntervalCheck = function () {
			$scope.badIntervalStatus = $scope.badInterval();
			$scope.$applyAsync();
		};

		$scope.badInterval = function () {
			const duration = parseInt(jsDataService.data.item.duration, 10);
			const monthTo = parseInt($scope.item.month_to, 10);

			if (isNaN(duration) || isNaN(monthTo)) {
				return false;
			}
			return monthTo > duration;
		};

		// Initial badInterval check
		$scope.triggerBadIntervalCheck();

	}
}


